<template>
  <div class="home">
    <button class="btn btn-primary" @click="testAxios()">
      Test Headers (retrieve all users)
    </button>
    <div>{{ users }}</div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      users: {}
    };
  },
  methods: {
    testAxios() {
      this.$gwzApi
        .service("users")
        .list()
        .then(res => {
          this.users = res.data["hydra:member"];
        });
    }
  }
};
</script>
